// The shared dialog of the setup wizards (a Pico modal): title, body and a row of
// buttons. A wizard draws its steps with show(); closing the dialog by any route
// (X, Esc, click on the backdrop) goes through the wizard's own onRequestClose so
// it can end a running pin test properly first.

const $ = (id) => document.getElementById(id);

export function button(label, onclick, cls = '') {
  const b = Object.assign(document.createElement('button'), { textContent: label, className: cls });
  b.onclick = onclick;
  return b;
}

export function paragraph(html) {
  const p = document.createElement('p');
  p.innerHTML = html;
  return p;
}

// Enter in a text field presses `target` (a button) instead of doing nothing.
export function enterPresses(input, target) {
  input.addEventListener('keydown', (e) => {
    if (e.key !== 'Enter' || e.isComposing) return;
    e.preventDefault();
    e.stopPropagation(); // the dialog's own fallback (the last button of the footer) must not fire as well
    if (!target.disabled) target.click();
  });
}

// Returns { show(title, nodes, buttons), close() }.
export function openWizardDialog({ onRequestClose }) {
  const dialog = $('wizard-dialog');
  const root = document.documentElement;

  dialog.onclick = (e) => {
    if (e.target === dialog) onRequestClose(); // click on the backdrop
  };
  dialog.oncancel = (e) => {
    e.preventDefault(); // Esc: same as the X
    onRequestClose();
  };
  $('wizard-close').onclick = onRequestClose;
  // Enter in a text field: the last button of the footer is the default action (Next, Save, ...).
  // Fields that belong to a button inside the body use enterPresses() instead.
  dialog.onkeydown = (e) => {
    if (e.key !== 'Enter' || e.isComposing || e.target.tagName !== 'INPUT' || !['text', 'password', 'url', 'search'].includes(e.target.type)) return;
    const primary = [...$('wizard-actions').querySelectorAll('button')].pop(); // the last one: Next, Save, ...
    e.preventDefault();
    if (primary && !primary.disabled) primary.click(); // a disabled Next (nothing typed yet) does nothing

  };
  dialog.onclose = () => root.classList.remove('modal-is-open', 'modal-is-opening');

  root.classList.add('modal-is-open', 'modal-is-opening');
  setTimeout(() => root.classList.remove('modal-is-opening'), 400);
  dialog.showModal();

  return {
    show(title, nodes, buttons) {
      $('wizard-title').textContent = title;
      $('wizard-body').replaceChildren(...nodes);
      $('wizard-actions').replaceChildren(...buttons);
    },
    close() {
      if (dialog.open) dialog.close();
    },
  };
}

// A list of steps with a marker left of each: pending (circle), working (spinner), done (check mark), failed (cross).
// `current` is the text of the step being worked on (earlier ones are done); failed marks it as failed.
export function stepList(texts, current, failed = false) {
  const ul = document.createElement('ul');
  ul.className = 'steps';
  const at = texts.indexOf(current);
  texts.forEach((text, i) => {
    const li = document.createElement('li');
    li.textContent = text;
    li.dataset.state = at < 0 ? 'pending' : i < at ? 'done' : i === at ? (failed ? 'failed' : 'working') : 'pending';
    ul.append(li);
  });
  return ul;
}
